export default "__VITE_ASSET__lWoBDFsw__"